import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <section className="w-full px-4 md:px-8 py-24 md:py-32">
      <div className="relative max-w-2xl mx-auto text-center">
        <span className="font-display text-7xl md:text-9xl text-primary-100 select-none" aria-hidden="true">
          404
        </span>
        <h1 className="mt-4 text-2xl md:text-4xl font-bold text-foreground-950">
          这块瓜田还没种上东西
        </h1>
        <p className="mt-3 text-sm md:text-base text-foreground-600">
          你访问的页面不存在或已被调整。路径：
          <span className="ml-1 text-foreground-800">{location.pathname}</span>
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm whitespace-nowrap hover:bg-primary-600 transition-colors"
          >
            <i className="ri-home-4-line w-4 h-4 flex items-center justify-center" />
            返回首页
          </Link>
          <Link
            to="/topics"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-background-50 border border-background-300 text-foreground-800 text-sm whitespace-nowrap hover:border-primary-300 transition-colors"
          >
            去看看话题榜
          </Link>
        </div>
      </div>
    </section>
  );
}